module.exports = __webpack_public_path__ + "img/media_video.9966f8f7.svg";